export const regex = ((src, flags) => new RegExp(src, flags));
Object.assign(regex, { cast: regex });
